import { ICreateFavoriteVO, IOrganizationCarrouselInfoVO } from "../model/ItemModel";
import { Api } from "./api";

export async function createFavorite(input: ICreateFavoriteVO) {
    const request = await Api.post<IOrganizationCarrouselInfoVO>(`favorite/create`, input);
    return request.data; 
}

export async function getAllFavorites(organizationInternalName: string, userId: string) {
    const request = await Api.get<IOrganizationCarrouselInfoVO>(`favorite/all/${organizationInternalName}/${userId}`);
    return request.data; 
}

export async function deleteFavorite(organizationInternalName: string, userId: string, favoriteId: string) {
    const request = await Api.delete<IOrganizationCarrouselInfoVO>(`favorite/delete/${organizationInternalName}/${userId}/${favoriteId}`);
    return request.data; 
}